import { restApiRequestDownload, getErrorMessage } from './ajax'
import saveAs from 'file-saver'

const bundleDownload = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * 計測期間一覧画面配下の計測期間レポートを取得する
     * @param {*} params
     */
    getDownload: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        const agencyId = params.agencyId
        const advertiserId = params.advertiserId
        const deliveryMonth = params.deliveryMonth
        const campaignPeriodIds = params.campaignPeriodIds
        const charset = params.charset

        restApiRequestDownload(
          baseURL,
          `/csv/bundle-download/campaign-period/${params.privateCode}/${agencyId}/${advertiserId}/${deliveryMonth}/${campaignPeriodIds}/${charset}`,
          params.jwtToken
        )
          .then(response => {
            const blob = new Blob([response.data], {
              type: response.data.type
            })
            if (response.status === 200) {
              // レスポンスヘッダから csv ファイル名を取得
              const contentDisposition = response.headers['content-disposition']
              const fileName = getFileName(contentDisposition)
              saveAs(blob, fileName)
              resolve(response.data)
            } else {
              reject(new ReferenceError(getErrorMessage('system error')))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
              return
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
      function getFileName(contentDisposition) {
        let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2, contentDisposition.length)
        // デコードするとスペースが"+"になるのでスペースへ置換
        fileName = decodeURI(fileName).replace(/\+/g, ' ')
        return fileName
      }
    }
  }
}

export default bundleDownload
